import { CancelTokenSource } from "axios"
import { reactive } from "vue"
import { usarRegex } from "@/composable/UsarRegex/usarRegex"

const { compararStringsComCoringa } = usarRegex()

interface CancelarRequisicoes {
  tokensDeCancelamento: { fonte: CancelTokenSource, url: string }[]
  requisicoesIncancelaveis: string[]
  adicionarToken(fonte: CancelTokenSource, url: string | undefined): void
  limparTokensDeCancelamento(): void
  cancelarRequisicoesPendentes(): void
  ignorarRequisicao(requisicao: string | string[]): void
}

export const cancelamento = reactive<CancelarRequisicoes>({
  tokensDeCancelamento: [],
  requisicoesIncancelaveis: [],
  adicionarToken(fonte: CancelTokenSource, url: string) {
    this.tokensDeCancelamento.push({
      fonte,
      url,
    })
  },
  ignorarRequisicao(requisicao: string | string[]) {
    if (Array.isArray(requisicao)) {
      this.requisicoesIncancelaveis.push(...requisicao)
    } else {
      this.requisicoesIncancelaveis.push(requisicao)
    }
  },
  limparTokensDeCancelamento() {
    this.tokensDeCancelamento = []
  },
  cancelarRequisicoesPendentes() {
    this.tokensDeCancelamento.forEach((request) => {
      const ehParaIgnorarRequisicao = this.requisicoesIncancelaveis.some(url => compararStringsComCoringa(url, request.url))
      if (ehParaIgnorarRequisicao) {
        return
      }
      if (request.fonte.cancel) {
        request.fonte.cancel("cancelado")
      }
    })
    this.limparTokensDeCancelamento()
  },
})
